/** Dashboard widgets domain storage. Per-tab (sessionStorage) saved filters per widget instance. */
import Storage from '../index';
import StorageKeys from '../keys';

const widgets = {
    getFilters: (widgetId, id) => Storage.get(StorageKeys.widgetFilters(widgetId, id), null),
    setFilters: (widgetId, id, filters) => Storage.set(StorageKeys.widgetFilters(widgetId, id), filters),
};

export default widgets;
